export const BannerTestAttributes = {
    action: 'banner-action',
    close: 'banner-close',
};
